import React from "react";
import Page from "../../../layout/web/Page";
import Title from "../../../components/Common/Title";
import Connector from "../../../redux/connector";
import {GetUserToken} from "../../../api/token";
import PluginAddDeleteList from "../../../components/General/PluginAddDeleteList";
import {PostToPbx} from "../../../api/http-post";
import {LoadDataAnyEndpoint} from "../../../api/fn";
import moment from "moment";


class WorkboardLeadPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Data: [],
            Modules: [],
            Products: [],
            isLoading: false,
            component: "list",
            newEntry: {},
            Users: [],
        }
    }

    componentDidMount = async () => {

        await this.loadInitialData()
    }

    loadInitialData = async () => {
        /*
        await this.loadData("insurer","Insurers");
        await this.loadData("product","Products")
        */
        await this.loadUsers();
    }
    loadUsers = async () => {
        let userInfo = GetUserToken();
        let hub = {};
        // hub.Org = userInfo.Org;
        let endpoint = "/user/list";
        await LoadDataAnyEndpoint(hub, endpoint, "Users", this, (data) => {
            console.log("loadUsers > ", data)
        });

    }
    loadData = async (targetEntity, stateKey) => {
        let _this = this;
        let userInfo = GetUserToken();
        let table = targetEntity;
        let hub = {};
        hub.Org = userInfo.Org;
        let post = {}
        post.AutoGenerate = false;
        post.HasUniqueKey = false;
        post.AutoGenerateField = "";
        post.Data = {};
        post.Params = {}
        post.Entity = table;
        let endpoint = "/common/entity/" + table + "/list";
        this.setState({
            isLoading: true,
        })

        await PostToPbx(post, endpoint, async (data) => {
            console.log("WorkboardLeadPage loadInitialData response > ", post, " > ", data);
            await _this.setState({
                [stateKey]: data.RESULT
            })
        });
    }

    getReason = () => {

        return [
            {key: "Assistance", val: "Assistance"},
            {key: "Police", val: "Police"},
            {key: "Hospital", val: "Hospital"},
        ]
    }
    getUsers = () => {
        let ls = [];
        for (let i in this.state.Users) {
            let row = this.state.Users[i];
            if (row.Org !== this.state.selectedCompany) {
                continue
            }
            ls.push({
                key: row.Username,
                val: row.FullName,
            })
        }
        return ls
    }
    getCreatedBy = () => {
        let userInfo = GetUserToken();
        return userInfo.Username;
    }
    getWorkDate = () => {
        return moment().format("YYYY-MM-DD HH:mm:ss")
    }


    render() {
        let reasons = this.getReason();
        let users = this.getUsers();
        return (
            <Page {...this.props}>
                <div style={{
                    minHeight: "100%",
                    maxHeight: "100%",
                }}>
                    <Title style={styles.title}>Lead Request</Title>
                    <div style={{minWidth: "100%", padding: 10}}>
                        <PluginAddDeleteList
                            _this={this}
                            targetEntity={"Callbacks"}
                            fields={[
                                {name: "phone", dataType: "string", required: true, label: "Phone Number", options: []},
                                {name: "email", dataType: "string", required: true, label: "Email", options: []},
                                {
                                    name: "contactperson",
                                    dataType: "string",
                                    required: true,
                                    label: "Contact Person",
                                    options: []
                                },
                                {name: "subject", dataType: "string", required: true, label: "Subject", options: []},
                                {name: "Reason", dataType: "option", required: true, label: "Reason", options: reasons},
                                {name: "message", dataType: "string", required: true, label: "Message", options: []},
                                {name: "address", dataType: "string", required: false, label: "Address", options: []},
                                {name: "city", dataType: "string", required: false, label: "City", options: []},
                                {name: "province", dataType: "string", required: false, label: "Province", options: []},
                                {name: "region", dataType: "string", required: false, label: "Region", options: []},
                                {
                                    name: "assignto",
                                    dataType: "option",
                                    required: false,
                                    label: "Assign To",
                                    options: users
                                },

                            ]}
                            deleteKeys={[
                                {key: "org", type: "string"},
                                {key: "project", type: "string"},
                                {key: "phone", type: "string"},
                                {key: "id", type: "string"},
                            ]}
                            stateArray={"Data"}
                            table={"Callbacks"}
                            addFormText={"Lead"}
                            stepTitle={"Set Up new lead"}
                            displayRules={[
                                {rowKey: "org", stateKey: "selectedCompany"},
                                {rowKey: "project", stateKey: "selectedProject"}
                            ]}
                            filterByCompany={true}
                            filterByModule={true}
                            injectFields={[
                                {
                                    rowKey: "Org",
                                    stateKey: "selectedCompany",
                                    errorMsg: "Sorry you can't save, Please select your company!"
                                },
                                {
                                    rowKey: "Project",
                                    stateKey: "selectedProject",
                                    errorMsg: "Sorry you can't save, Please select your Project!"
                                }
                            ]}
                            injectStaticValue={[
                                {key: "CreatedBy", val: this.getCreatedBy()},
                                {key: "WorkDate", val: this.getWorkDate()}
                            ]}
                        />
                    </div>
                </div>
            </Page>
        )
    }

}


export default Connector(WorkboardLeadPage);

const styles = {
    container: {},
    title: {
        minWidth: "100%",
        borderBottomWidth: 1,
        borderColor: "gray"
    }
}
